import { useMemo } from 'react';
import { useGetLocalTournaments, useGetProviderTournaments } from 'react-easyrocket';

export function useGetCountOfTournaments() {
  const {
    tournaments: localTournaments,
    isFetching: isFetchingLocal,
    isFetched: fetchedLocal
  } = useGetLocalTournaments();
  const {
    tournaments: providerTournaments,
    isFetching: isFetchingProviders,
    isFetched: fetchedProviders
  } = useGetProviderTournaments({});

  const localTournamentsCount = useMemo(() => {
    if (!localTournaments?.active) {
      return 0;
    }
    return localTournaments?.active?.length;
  }, [localTournaments]);

  const allTournaments = useMemo(() => {
    const alreadyFetched = fetchedLocal && fetchedProviders;
    if ((isFetchingLocal || isFetchingProviders) && !alreadyFetched) return 0;
    return localTournamentsCount + providerTournaments?.length;
  }, [
    fetchedLocal,
    fetchedProviders,
    isFetchingLocal,
    isFetchingProviders,
    localTournamentsCount,
    providerTournaments?.length
  ]);

  return allTournaments;
}
